import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser'


@Injectable()
export class MetaService {

  private defaultTitle: string;
  private defaultDescr: string;

  constructor(private meta: Meta,
              private title: Title) {

    this.defaultTitle = "The Paragons";
    this.defaultDescr = "Market for gentlemen's clothing"
  }

  public reset(): void {

    this.setTitle(this.defaultTitle);
    this.setDescription(this.defaultDescr);
  }

  public setTitle(title: string): void {

    this.title.setTitle(title);
  }

  public setDescription(description: string) {

    this.meta.updateTag({name: 'description', content: description});
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/meta.ts